import { render, staticRenderFns } from "./PageComisionChip.vue?vue&type=template&id=9b4e7574&"
import script from "./PageComisionChip.vue?vue&type=script&lang=js&"
export * from "./PageComisionChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports